<template>
    <div>
        <el-upload
                :action="action"
                :data="{'biz':bizPath}"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :before-upload="beforeUpload"
                :on-success="onSuccess"
                :multiple="multiple"
                :limit="number"
                :on-exceed="handleExceed"
                :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <!--            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
        </el-upload>
    </div>
</template>

<script>
    export default {
        name: "FileUpload",
        props: {
            value: {
                type:[String,Array],
                required:false
            },
            fileType:{
                type:String,
                required:false,
                default: 'all'
            },
            bizPath:{
                type:String,
                required:false,
                default:"temp"
            },
            number: {
                type: Number,
                required: false,
                default: 1
            },
            multiple: {
                type: Boolean,
                default: false
            },
			fileList:[]
        },
        watch: {
            value:{
                immediate: true,
                    handler(val) {
                    if(val){
                        this.fileList = [];
                        if (val instanceof Array) {
                            for(let url of val){
                                this.fileList.push({name: url.substr(url.lastIndexOf("/")+1),url:url})
                            }
                        } else {
                            var files = val.split(",");
                            for(let url of files){
                                this.fileList.push({name: url.substr(url.lastIndexOf("/")+1),url:url})
                            }
                        }
                    }

                }
            }
        },
        data() {
            return {
                action: '',
                
            };
        },
        created() {
            this.action = this.baseURL + "/sys/common/upload"

			
        },
        methods: {
            beforeUpload(file,fileList){


                const fileName = file.name;
                const fileType = file.type;
                const fileSuffix = fileName.substr(fileName.lastIndexOf(".")+1);
                const fileTypes = this.fileType.split(",");
                if(this.fileType == 'image'){
                    if(fileType.indexOf('image')<0){
                        this.$message.warning('请上传图片');
                        return false;
                    }
                }else if(fileTypes.indexOf(fileSuffix) == -1){
                    this.$message.warning('请选择'+this.fileType+"文件进行上传");
                    return false
                }
            },
            handleRemove(file, fileList) {

            },
            handlePreview(file) {

            },
            handleExceed(files, fileList) {
                this.$message.warning(`最多只能上传${this.number}个文件`);
            },
            beforeRemove(file, fileList) {
                if (file && file.status === "success") {
                    //移除方法
                    return this.$confirm(`确定移除 ${file.name}？`);
                }
            },
            onSuccess(response, file, fileList){
                const data = {};
                data.fileNames = [];
                data.filUrl= [];
                for(let fileD of fileList){
                    if(fileD && "success" == fileD.status){
                       let fName = fileD.name;
                       let fUrl = "";
                        if(fileD.response){
                            fUrl = fileD.response.message;
                        }else{
                            fUrl = fileD.url;
                        }
                        data.fileNames.push(fName);
                        data.filUrl.push(fUrl);
                    }
                }

                this.$emit("change",data)
            }
        }
    }
</script>

<style scoped>

</style>
